<template slot-scope="scope">
  <el-select
    v-model="localValue"
    :disabled="disabledFlag"
    @input="$emit('input', $event)"
    @focus="chooseWeek"
    placeholder="选择教学周"
    clearable style="width: 100%" class="chooseWeek">
    <el-option v-for="(item,index) in weeknum" :key="item.id" :label="item.value" class="localoption" :value="item.id"></el-option>
  </el-select>
</template>
<script>
  export default {
    props: {
      value: null,
      campusId: {
        type: String,
        default: '',
      },
      leamTermId: {
        type: String,
        default: '',
      },
      disabledFlag: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      value(val){
        this.localValue = val;
      },
      campusId(val){
        this.campusId = val;
        this.query()
      }
    },
    data() {
      return {
        localValue: this.value,
        teachWeeks:[],
        weeknum:[],
        items:[]
      }
    },
    methods: {
      chooseWeek(){
        let vm = this;
        if(vm.campusId == null||vm.campusId == ''){
          vm.$message({
            message: '请选择校区',
            type: 'warning'
          });
        }else {
          vm.query()
        }
      },
      query(){
        let vm = this;
        if(vm.campusId == null||vm.campusId == ''){
          vm.teachWeeks = [];
          return;
        }

        var weekIndex = -1;
        let obj = {
          campusId:vm.campusId,
        }
        http.get(InterfacePrefix['platform'] + '/teachingWeek/current',{params:obj})
          .then(function (xhr) {
            if (xhr.data.code) return // 异常情况有公共处理
            if (xhr.data != null&&xhr.data != ''){
              weekIndex = xhr.data.weekNum;
              let objs = new Object();
              if (vm.leamTermId != null || vm.leamTermId != ''){
                objs.campusId = vm.campusId;
                objs.leamTermId = vm.leamTermId;
              }else {
                objs.campusId = vm.campusId;
              }
              vm.weeknum = [];
              http.get(InterfacePrefix['platform'] + '/teachingWeek',{params:objs})
                .then(function (xhr) {
                  if (xhr.data.code) return // 异常情况有公共处理
                  vm.teachWeeks = xhr.data;
                  _.forEach(vm.teachWeeks,function (v) {
                    if(v.weekNum == weekIndex){
                      vm.weeknum.push({value:"当前：第"+v.weekNum+"周",id:v.id});
//                vm.localValue="当前：第"+v.weekNum+"周";
                    } else {
                      vm.weeknum.push({value:"第"+v.weekNum+"周",id:v.id})
                    }
                  })
                })
            }
          })

      }
    },
    mounted() {
    },
  }

</script>



// WEBPACK FOOTER //
// src/commonplugin/chose_param/chooseTeachWeek.vue